/**
 * Extension Handler for Gas Spring Configurator
 * Handles the display and interaction of mounting parts with extensions
 */
class ExtensionHandler {
    
    constructor() {
        this.init();
    }
    
    init() {
        this.bindEvents();
    }
    
    bindEvents() {
        // Bind hover events for extension parts
        $(document).on('mouseenter', '.extension-rod-section', this.showRodDetails.bind(this));
        $(document).on('mouseleave', '.extension-rod-section', this.hideRodDetails.bind(this));
        $(document).on('mouseenter', '.extension-part-section', this.showExtensionDetails.bind(this));
        $(document).on('mouseleave', '.extension-part-section', this.hideExtensionDetails.bind(this));
    }
    
    /**
     * Check if a mounting part has extensions
     * @param {Object} mp - The mounting part object
     * @param {string} selectId - The select ID to determine which mounting part this is
     * @returns {boolean} - True if the part has extensions
     */
    hasExtensions(mp, selectId) {
        if (typeof window.cf === 'undefined' || !window.cf.ex) {
            return false;
        }

        // Only the rod mounting-part dropdown shows the extender column.
        if (!selectId || !selectId.startsWith('mp_rod')) {
            return false;
        }

        return $('#use_extension_checkbox').is(':checked');
    }
    
    /**
     * Get extension data for a mounting part
     * @param {Object} mp - The mounting part object
     * @param {string} selectId - The select ID to determine which mounting part this is
     * @returns {Object|null} - Extension data or null if no extension
     */
    getExtensionData(mp, selectId) {
        if (!this.hasExtensions(mp, selectId)) {
            return null;
        }
        
        // First check if there's an active extension in the configurator
        if (typeof window.cf !== 'undefined' && window.cf.ex) {
            return window.cf.ex;
        }
        
        // Fallback: Find the extension part in the array (usually the second element)
        const extensionType = mp.type_aanbouwdeel_array[1];
        if (!extensionType || extensionType === '') {
            return null;
        }
        
        // Find the extension mounting part data
        for (let i = 0; i < mp_data.length; i++) {
            const extensionMp = mp_data[i];
            if (extensionMp.type_aanbouwdeel === extensionType && 
                extensionMp.dschroefdraad === mp.dschroefdraad &&
                extensionMp.materiaal === mp.materiaal) {
                return extensionMp;
            }
        }
        
        return null;
    }
    
    /**
     * Show extension view for a list item
     * @param {jQuery} $li - The list item element
     * @param {Object} mp - The mounting part object
     * @param {Object} extensionMp - The extension mounting part object
     */
    showExtensionView($li, mp, extensionMp) {
        // Hide standard view
        const $standardView = $li.find('[data-show="standard"]');
        $standardView.hide();
        
        // Hide SKU and stock data
        $li.find('.product-sku').hide();
        $li.find('.product-stock').hide();
        
        // Hide 2D CAD button
        $li.find('.btn_2d_cad').hide();
        
        // Show extension view
        const $extensionView = $li.find('[data-show="extension"]');
        $extensionView.show();
        
        // Update rod section
        this.updateRodSection($li, mp);
        
        // Update extension section
        this.updateExtensionSection($li, extensionMp);
    }
    
    /**
     * Show standard view for a list item
     * @param {jQuery} $li - The list item element
     */
    showStandardView($li) {
        $li.find('[data-show="standard"]').show();
        $li.find('[data-show="extension"]').hide();
        
        // Show SKU and stock data
        $li.find('.product-sku').show();
        $li.find('.product-stock').show();
        
        // Show 2D CAD button
        $li.find('.btn_2d_cad').show();
    }
    
    /**
     * Update the rod section with main part data
     * @param {jQuery} $li - The list item element
     * @param {Object} mp - The mounting part object
     */
    updateRodSection($li, mp) {
        const $rodSection = $li.find('.extension-rod-section');
        
        // Update image
        $rodSection.find('.extension-rod-image img').attr('src', mp.dropdown_img_src);
        
        // Update specs
        const rodSpecs = this.formatSpecs(mp);
        $rodSection.find('.extension-rod-specs').html(rodSpecs);
    }
    
    /**
     * Update the extension section with extension part data
     * @param {jQuery} $li - The list item element
     * @param {Object} extensionMp - The extension mounting part object
     */
    updateExtensionSection($li, extensionMp) {
        const $extensionSection = $li.find('.extension-part-section');
        
        // Update image - set both src and data-src attributes
        let $extensionImage = $extensionSection.find('.extension-part-image img');
        
        // If image element doesn't exist, create it
        if ($extensionImage.length === 0) {
            const $imageContainer = $extensionSection.find('.extension-part-image');
            $imageContainer.html('<img loading="lazy" class="flhtmls-li-img" data-src="' + extensionMp.dropdown_img_src + '" alt="" src="' + extensionMp.dropdown_img_src + '"/>');
            $extensionImage = $imageContainer.find('img');
        }
        
        if ($extensionImage.length > 0) {
            $extensionImage.attr('src', extensionMp.dropdown_img_src);
            $extensionImage.attr('data-src', extensionMp.dropdown_img_src);
        }
        
        // Update specs - use a different format for extensions
        const extensionSpecs = this.formatExtensionSpecs(extensionMp);
        $extensionSection.find('.extension-part-specs').html(extensionSpecs);
    }
    
    /**
     * Format specs for display
     * @param {Object} mp - The mounting part object
     * @returns {string} - Formatted specs HTML
     */
    formatSpecs(mp) {
        let specs = '';
        
        if (mp.dschroefdraad) {
            specs += '<div class="product-spec metric"><span class="spec-label">' + texts.refine_thread_text + '</span><span class="spec-value">M' + mp.dschroefdraad + '</span></div>';
            specs += '<div class="product-spec imperial"><span class="spec-label">' + texts.refine_thread_text + '</span><span class="spec-value">M' + mp.dschroefdraad + '</span></div>';
        }
        
        if (mp.elongationlength) {
            specs += '<div class="product-spec metric"><span class="spec-label">' + texts.refine_length_text + '</span><span class="spec-value">' + mp.elongationlength + '&nbsp;mm</span></div>';
            specs += '<div class="product-spec imperial"><span class="spec-label">' + texts.refine_length_text + '</span><span class="spec-value">' + mm_to_inch(mp.elongationlength) + '"</span></div>';
        }
        
        if (mp.maxforceallowed) {
            specs += '<div class="product-spec metric"><span class="spec-label">' + texts.refine_maxforceallowed_text + '</span><span class="spec-value">' + mp.maxforceallowed + '&nbsp;N</span></div>';
            specs += '<div class="product-spec imperial"><span class="spec-label">' + texts.refine_maxforceallowed_text + '</span><span class="spec-value">' + newton_to_lbs(mp.maxforceallowed) + '&nbsp;lbs</span></div>';
        }
        
        if (mp.dikte) {
            specs += '<div class="product-spec metric"><span class="spec-label">' + texts.refine_thickness_text + '</span><span class="spec-value">' + mp.dikte + '&nbsp;mm</span></div>';
            specs += '<div class="product-spec imperial"><span class="spec-label">' + texts.refine_thickness_text + '</span><span class="spec-value">' + mm_to_inch(mp.dikte) + '"</span></div>';
        }
        
        if (mp.gat) {
            specs += '<div class="product-spec metric"><span class="spec-label">' + texts.refine_hole_text + '</span><span class="spec-value">' + mp.gat + '&nbsp;mm</span></div>';
            specs += '<div class="product-spec imperial"><span class="spec-label">' + texts.refine_hole_text + '</span><span class="spec-value">' + mm_to_inch(mp.gat) + '"</span></div>';
        }
        
        if (mp.price) {
            const price = config_price_ex ? mp.price_ex : mp.price;
            specs += '<div class="product-spec metric"><span class="spec-label-price">' + texts.refine_price + '</span><span class="spec-value-price">' + cf.format_price(price) + '</span></div>';
            specs += '<div class="product-spec imperial"><span class="spec-label-price">' + texts.refine_price + '</span><span class="spec-value-price">' + cf.format_price(price) + '</span></div>';
        }
        
        return specs;
    }
    
    /**
     * Format specs for extensions (different structure than mounting parts)
     * @param {Object} extension - The extension object
     * @returns {string} - Formatted specs HTML
     */
    formatExtensionSpecs(extension) {
        let specs = '';
        
        // Show thread diameter
        if (extension.dschroefdraad) {
            specs += '<div class="product-spec metric"><span class="spec-label">' + texts.refine_thread_text + '</span><span class="spec-value">M' + extension.dschroefdraad + '</span></div>';
            specs += '<div class="product-spec imperial"><span class="spec-label">' + texts.refine_thread_text + '</span><span class="spec-value">M' + extension.dschroefdraad + '</span></div>';
        }
        
        if (extension.elongation) {
            specs += '<div class="product-spec metric"><span class="spec-label">' + texts.refine_length_text + '</span><span class="spec-value">' + extension.elongation + '&nbsp;mm</span></div>';
            specs += '<div class="product-spec imperial"><span class="spec-label">' + texts.refine_length_text + '</span><span class="spec-value">' + mm_to_inch(extension.elongation) + '"</span></div>';
        }
        
        if (extension.price) {
            const price = config_price_ex ? extension.price_ex : extension.price;
            specs += '<div class="product-spec metric"><span class="spec-label-price">' + texts.refine_price + '</span><span class="spec-value-price">' + cf.format_price(price) + '</span></div>';
            specs += '<div class="product-spec imperial"><span class="spec-label-price">' + texts.refine_price + '</span><span class="spec-value-price">' + cf.format_price(price) + '</span></div>';
        }
        
        return specs;
    }
    
    /**
     * Show rod details on hover
     * @param {Event} e - The mouse event
     */
    showRodDetails(e) {
        const $rodSection = $(e.currentTarget);
        $rodSection.find('.extension-rod-details').addClass('show-details');
    }
    
    /**
     * Hide rod details on mouse leave
     * @param {Event} e - The mouse event
     */
    hideRodDetails(e) {
        const $rodSection = $(e.currentTarget);
        $rodSection.find('.extension-rod-details').removeClass('show-details');
    }
    
    /**
     * Show extension details on hover
     * @param {Event} e - The mouse event
     */
    showExtensionDetails(e) {
        const $extensionSection = $(e.currentTarget);
        $extensionSection.find('.extension-part-details').addClass('show-details');
    }
    
    /**
     * Hide extension details on mouse leave
     * @param {Event} e - The mouse event
     */
    hideExtensionDetails(e) {
        const $extensionSection = $(e.currentTarget);
        $extensionSection.find('.extension-part-details').removeClass('show-details');
    }
    
    /**
     * Process a list item to handle extensions
     * @param {jQuery} $li - The list item element
     * @param {Object} mp - The mounting part object
     * @param {string} selectId - The select ID to determine which mounting part this is
     */
    processListItem($li, mp, selectId) {
        if (this.hasExtensions(mp, selectId)) {
            const extensionMp = this.getExtensionData(mp, selectId);
            if (extensionMp) {
                this.showExtensionView($li, mp, extensionMp);
            } else {
                this.showStandardView($li);
            }
        } else {
            this.showStandardView($li);
        }
    }
}

// Initialize the extension handler when document is ready
$(document).ready(function() {
    window.extensionHandler = new ExtensionHandler();
}); 